<template>
  <div id="app">
    <AppHeader />
    <router-view/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook.vue'
export default {
  name: 'App',
  components: {
    AppHeader,
    VueGoodshareFacebook
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
body {
  background: url('/static/code-coding-computer-34676.jpg') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue